import { RotateIcon } from "cssReset/icon";
import { useNavigate } from "react-router-dom";
import {
  NoDataBox,
  NoDataCard,
  SimpleTestListItemBox,
  SubItemWrapper,
} from "style/mypage";
import { getResultImageByType, getReultTypeTitle } from "utils/inspect.util";
import { formatDate } from "utils/util";

interface ListDataProps {
  data: any[];
}

const SimpleTestListItem = ({ data }: ListDataProps) => {
  const navigate = useNavigate();

  return (
    <SimpleTestListItemBox>
      {data && data.length !== 0 ? (
        <div className="list-wrapper">
          {data.map((item, index) => (
            <div key={index} className="itme-wrapper">
              <div className="title">
                <h4>층간소음 유형 간이검사</h4>
                <span>{formatDate(item.regDt)} 검사</span>
              </div>
              <div className="contents-box">
                <div className="img-box">
                  <img src={getResultImageByType(item.type)} alt="측정 결과" />
                </div>
                <div className="result-type">
                  <p>나의 층간소음 유형은</p>
                  <h4>{getReultTypeTitle(item.type)}</h4>
                </div>
              </div>
              <SubItemWrapper>
                <div
                  className="detail-veiw-btn"
                  onClick={() => {
                    navigate(
                      `/inspect/simple/result/preview/mypage/detail/${item.type}`
                    );
                  }}
                >
                  측정결과 자세히 보기
                </div>
                <span></span>
                <div
                  className="rotate"
                  onClick={() => {
                    navigate(`/inspect/simple/step`);
                  }}
                >
                  <span className="icon-box">
                    <RotateIcon />
                  </span>
                  측정 다시 하기
                </div>
              </SubItemWrapper>
            </div>
          ))}
        </div>
      ) : (
        <NoDataBox>
          <div className="title">
            <p>층간소음 유형 간이검사</p>
            <span>검사 정보 없음</span>
          </div>
          <NoDataCard>
            <p>검사 결과가 없습니다.</p>
            <button
              onClick={() => {
                navigate(`/inspect/simple/step`);
              }}
            >
              5분만에 나의 층간소음 유형 알아보기
            </button>
          </NoDataCard>
        </NoDataBox>
      )}
    </SimpleTestListItemBox>
  );
};

export default SimpleTestListItem;
